import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import {AppState} from '../../../app/app.global';

import { StorageService } from '../../../providers/service/storageservice';

@Component({
  selector: 'page-messagedetail',
  templateUrl: 'messagedetail.html',
})
export class MessagedetailPage {
  user:any={};
  messageDetail:any = {};
  constructor(public navCtrl: NavController, public navParams: NavParams,public global:AppState,) {

    this.user = StorageService.getObj('currentUser');
    this.messageDetail = navParams.data;
  }

}



// WEBPACK FOOTER //
// ./src/pages/commonsearch/messagedetail/messagedetail.ts